// import 'babel-polyfill'
import Vue from "vue";
import App from "./App";
import VueTouch from "./plugins/touchEvent"; // 添加手势触摸事件，使用方法如 v-touch:swipeleft
import '@nutui/nutui/dist/nutui.css';
import * as uni from '@/sdk/uniapp_webview1.5.2.js';
document.addEventListener('UniAppJSBridgeReady', function() {
  Vue.prototype.myUni = uni  
})
Vue.use(VueTouch);
Vue.prototype.$bus = new Vue()
import store from "./store"; // 同步单页路由与数据中心
import router from "./router";
require("./utils/polyfill");
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js